@use '@design/design-tokens/breakpoints/breakpoints' as *;
@use '@design/design-tokens/typography/typography' as *;

.styledDropdownMenu {
  @include respond-to('mobile') {
    width: 250px;
    min-width: 250px;
  }
}

.optionWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  @include typography-v2-body-sm;
}

.styledInput {
  display: none;
}

.styledButton {
  &:disabled {
    border: none;
  }
}
